import { useMutation, useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { useFirebase } from 'components/Firebase/index.js';
import { useAlert } from 'contexts/AlertContext.jsx';
import { useLocalization } from 'contexts/LocalizationContext.jsx';
import useOrgId from 'hooks/useOrgId.js';

const useDeleteAvatarMutation = () => {
  const { t } = useLocalization();
  const firebase = useFirebase();
  const orgId = useOrgId();
  const uid = useSelector((state) => state.sessionState.authUser?.uid);
  const queryClient = useQueryClient();
  const { setAlert } = useAlert();

  return useMutation({
    mutationFn: async () => {
      const agent = await firebase.getAgent();
      await agent.delete(`/o/${orgId}/users/${uid}/avatar`);
    },
    onError: (error) => {
      console.error(error);
      setAlert({ title: t('genericLabels.error'), variant: 'danger' });
    },
    onSuccess: () => {
      queryClient.setQueryData(['o', orgId, 'user', uid], (oldData) => ({
        ...oldData,
        avatar: null,
      }));
    },
  });
};

export default useDeleteAvatarMutation;
